import { useEffect, useRef } from "react";

// react-table hands us an `indeterminate` flag, but that is a DOM property and
// not an attribute, so it has to be pushed onto the node by hand.
const Checkbox = ({ indeterminate, ...rest }) => {
  const ref = useRef();

  useEffect(() => {
    if (ref.current) {
      ref.current.indeterminate = !!indeterminate;
    }
  }, [indeterminate]);

  return (
    <input
      type="checkbox"
      ref={ref}
      className="agent-selection-checkbox"
      // The row itself navigates to the analysis report on click.
      onClick={(e) => e.stopPropagation()}
      {...rest}
    />
  );
};

// Selects every matching row, not just the current page: the table is fed data
// that is already filtered, so "all rows" is exactly "all matches".
export const AgentSelectAllCheckbox = ({ getToggleAllRowsSelectedProps }) => (
  <Checkbox {...getToggleAllRowsSelectedProps()} title="Select all matching agents" />
);

export const AgentRowCheckbox = ({ row }) => <Checkbox {...row.getToggleRowSelectedProps()} />;
